// @architect-approved: HARDCODED_COLORS - Index-keyed icon color-cycling palette
// (below); a data color series for directory icon variety, not UI chrome.
/**
 * Shared Icon Map — Resolves DB Display_Icon strings to MUI components
 *
 * All directory pattern components use this single source for icon resolution.
 * Add new icons here as the database vocabulary grows.
 *
 * Created: 2026-03-22
 */

import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessIcon from '@mui/icons-material/Business';
import ElevatorIcon from '@mui/icons-material/Elevator';
import ExploreIcon from '@mui/icons-material/Explore';
import FolderIcon from '@mui/icons-material/Folder';
import GroupsIcon from '@mui/icons-material/Groups';
import LoginIcon from '@mui/icons-material/Login';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import StorageIcon from '@mui/icons-material/Storage';
import StoreIcon from '@mui/icons-material/Store';
import TramIcon from '@mui/icons-material/Tram';
import WidgetsIcon from '@mui/icons-material/Widgets';
import React from 'react';

/** Map DB Icon_Name / Display_Icon string → MUI component */
export const ICON_MAP: Record<string, React.ReactElement> = {
    Store: <StoreIcon />,
    Business: <BusinessIcon />,
    Groups: <GroupsIcon />,
    Explore: <ExploreIcon />,
    Login: <LoginIcon />,
    Tram: <TramIcon />,
    Elevator: <ElevatorIcon />,
    Apartment: <ApartmentIcon />,
    Storage: <StorageIcon />,
    Folder: <FolderIcon />,
    SmartToy: <SmartToyIcon />,
    Widgets: <WidgetsIcon />,
};

/** Fallback icon when Display_Icon is null or unrecognized */
export const DEFAULT_ICON = <WidgetsIcon />;

/** Resolve an icon name to a MUI element with optional sx override */
export function resolveIcon(iconName: string | null, sx?: Record<string, any>): React.ReactElement {
    if (!iconName) return React.cloneElement(DEFAULT_ICON, { sx });
    const icon = ICON_MAP[iconName];
    if (!icon) return React.cloneElement(DEFAULT_ICON, { sx });
    return sx ? React.cloneElement(icon, { sx }) : icon;
}

/** Floor-based color fallback when Icon_Color is null */
export const FLOOR_COLORS: Record<number, string> = {
    0: '#E91E63',
    1: '#9C27B0',
    2: '#673AB7',
    3: '#3F51B5',
    4: '#2196F3',
    5: '#00BCD4',
    6: '#009688',
};
